<template>
    <div>
        <v-dialog max-width="400px" persistent v-model="showChangeLoggedUserPasswordModal" @close="close">
            <v-card>
                <v-card-title class="blue-grey lighten-3 white--text">
                    <span class="headline">Alterar minha Senha</span>
                </v-card-title>

                <v-card-text>

                    <!--Current password-->
                    <v-text-field v-model="current_pass"
                                  :error-messages="currentPasswordErrors"
                                  @blur="$v.current_pass.$touch()"
                                  :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                  :type="showPassword ? 'text' : 'password'"
                                  @click:append="showPassword = !showPassword"
                                  @keyup.enter="$v.invalid ? '' : changePassword"
                                  label="Senha atual">
                    </v-text-field>

                    <br>

                    <!--New Password-->
                    <v-text-field v-model="new_pass"
                                  :counter="$v.new_pass.$params.maxLength.max"
                                  :error-messages="newPasswordErrors"
                                  @blur="$v.new_pass.$touch()"
                                  :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                  :type="showPassword ? 'text' : 'password'"
                                  @click:append="showPassword = !showPassword"
                                  @keyup.enter="$v.invalid ? '' : changePassword"
                                  label="Nova senha">
                    </v-text-field>

                    <!--Confirm new Password-->
                    <v-text-field v-model="conf_new_pass"
                                  :error-messages="confNewPasswordErrors"
                                  @blur="$v.conf_new_pass.$touch()"
                                  :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                  :type="showPassword ? 'text' : 'password'"
                                  @click:append="showPassword = !showPassword"
                                  @keyup.enter="$v.invalid ? '' : changePassword"
                                  label="Confirmar nova senha">
                    </v-text-field>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div v-if="!loading_modal">
                        <v-btn color="grey darken-1" flat="flat" @click="showChangeLoggedUserPasswordModal = false">
                            Cancelar
                        </v-btn>

                        <v-btn color="blue lighten-2 white--text" :disabled="$v.$invalid || new_pass !== conf_new_pass" @click="changePassword">
                            Confirmar
                        </v-btn>
                    </div>
                    <v-progress-circular v-else indeterminate color="primary" m-2 ></v-progress-circular>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {mapGetters} from 'vuex';
    import {maxLength, minLength, required} from 'vuelidate/lib/validators'
    import {eventBus} from "../../main";

    export default {
        name: "ChangePassword",

        data(){
            return{
                showPassword: false,
                loading_modal: false,

                current_pass: "",
                new_pass: "",
                conf_new_pass: "",

                //snackBar
                snackbar: true,
                text: '',
                snackbar_color: '',
            }
        },
        

        watch: {
            showChangeLoggedUserPasswordModal(){
                if(this.showChangeLoggedUserPasswordModal){
                    this.onChangeLoggedUserPasswordModalOpened();
                }else{
                    this.close();
                }
            },

        },

        validations:{
            current_pass: {
                required,
                minLength: minLength(6),
                maxLength: maxLength(40),
            },
            new_pass: {
                required,
                minLength: minLength(6),
                maxLength: maxLength(40),
            },
            conf_new_pass: {
                required,
            }
        },

        computed:{
            ...mapGetters([
                'getNewUser',
                'loggedUser',
                'getToken',
            ]),

            showChangeLoggedUserPasswordModal: {
                get(){
                    return this.$store.getters.getShowChangeLoggedUserPasswordModal;
                },
                set(value){
                    this.$store.dispatch('setShowChangeLoggedUserPasswordModal', value);
                }
            },

            selectedUser: {
                get(){
                    return this.$store.getters.getSelectedUser;
                },
                set(value){
                    this.$store.dispatch('setSelectedUser', value);
                }
            },

            currentPasswordErrors(){
                const errors = [];
                if (!this.$v.current_pass.$dirty) return errors;
                !this.$v.current_pass.minLength && errors.push('Mínimo de 6 caracteres');
                !this.$v.current_pass.maxLength && errors.push('Máximo de 40 caracteres');
                !this.$v.current_pass.required && errors.push('Digite a senha actual');
                return errors
            },

            newPasswordErrors(){
                const errors = [];
                if (!this.$v.new_pass.$dirty) return errors;
                !this.$v.new_pass.minLength && errors.push('Mínimo de 6 caracteres');
                !this.$v.new_pass.maxLength && errors.push('Máximo de 40 caracteres');
                !this.$v.new_pass.required && errors.push('Digite a nova senha');
                return errors
            },

            confNewPasswordErrors(){
                const errors = [];
                if (!this.$v.conf_new_pass.$dirty) return errors;
                !(this.new_pass === this.conf_new_pass) && errors.push('Confirmação não é igual à nova senha');
                !this.$v.conf_new_pass.required && errors.push('Digite a nova senha');
                return errors
            },
        },

        methods: {
            onChangeLoggedUserPasswordModalOpened(){
                this.current_pass = "";
                this.new_pass = "";
                this.conf_new_pass = "";
            },

            changePassword(){
                try{
                    this.loading_modal = true;

                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.post('user/change_my_pass', {
                        cur_password: this.current_pass,
                        new_password: this.new_pass,
                        user_id: this.loggedUser.id,
                    }).then(response => {
                        this.consoleLog(response);
                        if(response.data.response === "Incorrect password"){
                            this.showSnackBar('Senha atual incorreta.', 'error');
                        }
                        if(!response.data.success){
                            eventBus.$emit('onPasswordChanged', response);
                            return;
                        }


                        this.showSnackBar('Senha alterada com sucesso', 'success');
                        this.close();
                        eventBus.$emit('onPasswordChanged', response);
                    }).catch(error=>{
                        this.consoleLog(error);
                        eventBus.$emit('onPasswordChanged', null);
                    }).finally(()=>{
                        this.loading_modal = false;
                    });

                    // Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    // Vue.axios.post('user/change_my_pass/'+this.loggedUser.id, {
                    //     cur_password: this.cur_password,
                    //     new_password: this.new_password,

                    // }).then(response=>{
                    //     this.consoleLog(response);
                    //     if(!response.data.success){
                    //         eventBus.$emit('onPasswordChanged', response);
                    //         return;
                    //     }

                    //     if(response.data.response === "Incorrect password"){
                    //         this.showSnackBar('Senha atual incorreta.', 'error');
                    //         return;
                    //     }

                    //     this.close();
                    //     eventBus.$emit('onPasswordChanged', response);
                    // }).catch(error=>{
                    //     this.consoleLog(error);
                    //     eventBus.$emit('onPasswordChanged', null);
                    // }).finally(()=>{
                    //     this.loading_modal = false;
                    // });
                }catch (e) {
                    this.consoleLog(e);
                    eventBus.$emit('onPasswordChanged', null);
                }
            },

            close () {
                this.$v.$reset();
                this.current_pass = "";
                this.new_pass = "";
                this.conf_new_pass = "";
                this.showPassword = false;
                this.showChangeLoggedUserPasswordModal = false;
                this.loading_modal = false;
            },
        }
    }
</script>

<style scoped>

</style>